import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const BlogsPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Our <span className="text-gradient">Blog</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover insights, tutorials, and stories from the world of STEM education
            </p>
          </motion.div>
        </div>
      </section>

      {/* Blogs Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Robotics Blog */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="relative overflow-hidden">
                <video
                  src="/videos/Robotics-Blog-Cover.mp4"
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <span className="bg-primary-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Robotics
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors">
                  Building Your First Robot: A Complete Guide
                </h3>
                <p className="text-gray-600 mb-4">
                  Learn the fundamentals of robotics with our step-by-step guide to building your first robot from scratch.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">Dec 15, 2024</span>
                  <Link 
                    to="/blogs/robotics-guide"
                    className="text-primary-600 font-medium hover:text-primary-700 transition-colors"
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            </motion.div>

            {/* STEM Workshops Blog */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="relative overflow-hidden">
                <video
                  src="/videos/STEM-Blog-cover.mp4"
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Workshops
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors">
                  Free STEM Workshops: What to Expect
                </h3>
                <p className="text-gray-600 mb-4">
                  Everything you need to know about our free STEM workshops and how they can spark your child's interest in science.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">Dec 10, 2024</span>
                  <Link 
                    to="/blogs/stem-workshops"
                    className="text-primary-600 font-medium hover:text-primary-700 transition-colors"
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            </motion.div>

            {/* Tech Entrepreneurship Blog */}
            {/* BlogsPage: Entrepreneurship card */}
            <Link to="/blogs/entrepreneurship" className="block group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative overflow-hidden">
                <video
                  src="/videos/techentrepreneurship-cover.mp4"
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  autoPlay loop muted playsInline
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <span className="bg-purple-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Entrepreneurship
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors">
                  From Early Age to Tech Entrepreneur: The Journey Begins at STEM Bears Labs
                </h3>
                <p className="text-gray-600 mb-4">
                  Every inventor starts somewhere often young, fueled by curiosity.<br />
                  At STEM Bears Labs, we plant the seeds of entrepreneurship early.<br />
                  Our journey: from playful circuits to building innovators.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">Jan 2025</span>
                  <span className="text-primary-600 font-medium">Read More →</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default BlogsPage
